export const prefersReducedMotionMediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
export const noPreferenceMediaQuery = window.matchMedia('(prefers-reduced-motion: no-preference)');
export const noPreferenceReducedMotion = noPreferenceMediaQuery.matches;
export const prefersReducedMotion = prefersReducedMotionMediaQuery.matches;
//# sourceMappingURL=reducedMotion.js.map